export type AppPlatform = "ios" | "android" | "desktop";

export const APP_STORE_URL =
  "https://apps.apple.com/us/app/travela/id1562887010";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.travela.xyz";

/** The app's own URL scheme (`travela://`), registered on iOS and Android. */
const APP_SCHEME_URL = "travela://";
const ANDROID_PACKAGE = "com.travela.xyz";
const PRODUCTION_SITE = "https://travela.xyz";
const LOCAL_HOST =
  /^(localhost|127\.|0\.0\.0\.0|10\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.)|\.local$/;

export const appDownloadService = {
  /** iPadOS reports a Mac user agent; touch points tell the two apart. */
  platform(userAgent: string, maxTouchPoints = 0): AppPlatform {
    if (/android/i.test(userAgent)) return "android";
    if (/iphone|ipad|ipod/i.test(userAgent)) return "ios";
    if (/macintosh/i.test(userAgent) && maxTouchPoints > 1) return "ios";
    return "desktop";
  },

  /** Where the server sends a scanned phone; null keeps a desktop (or iPad, seen as a Mac) on the page. */
  phoneStoreUrl(userAgent: string): string | null {
    const platform = appDownloadService.platform(userAgent);
    return platform === "desktop"
      ? null
      : appDownloadService.storeUrl(platform);
  },

  storeUrl(platform: AppPlatform): string {
    return platform === "android" ? PLAY_STORE_URL : APP_STORE_URL;
  },

  /** Chrome opens the app when installed and Google Play when not, in one link. */
  androidIntentUrl(): string {
    return `intent://open#Intent;scheme=travela;package=${ANDROID_PACKAGE};S.browser_fallback_url=${encodeURIComponent(PLAY_STORE_URL)};end`;
  },

  appSchemeUrl(): string {
    return APP_SCHEME_URL;
  },

  /**
   * What the QR code opens: the public `/app` page, which sends a phone on to the app. A
   * phone can't reach a developer's machine, so a local origin points at production.
   */
  qrTarget(origin: string): string {
    let site = origin.replace(/\/$/, "");
    try {
      if (LOCAL_HOST.test(new URL(site).hostname)) site = PRODUCTION_SITE;
    } catch {
      site = PRODUCTION_SITE;
    }
    return `${site}/app`;
  },
};
